<script setup lang="ts">
import { computed } from 'vue';
import { container } from '@shared/common/dependency-injection/domain/container';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { FormFieldNumberComponent } from '@shared/common/form/application/component/number/form-field-number-component.types';
import type { NumberFormField } from '@shared/common/form/domain/form/field/number.form-field';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';
import { FeedbackMessage, FeedbackMessageState } from '@kiplin/web-common/design-system';

const model = defineModel<NumberFormField>({ required: true });
const component = container.get<FormFieldNumberComponent>(FormDependencyTypes.FormFieldNumberComponent);

const message = computed(() => model.value.errorMessages?.[0]);
const additionalErrors = computed(() => model.value.errorMessages?.slice(1));
</script>

<template>
  <div>
    <component
      :is="component"
      v-model="model.value"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :disabled="model.disabled"
      :readonly="model.readonly"
      :required="model.required"
      :min="model.min"
      :max="model.max"
      :step="model.step"
      :message="message"
      :error="message"
    />
    <FeedbackMessage v-if="model.warning" class="mt-2" :text="model.warning" :state="FeedbackMessageState.Default" />
    <FormFieldMessages :errors="additionalErrors" />
  </div>
</template>
